import { createSlice } from '@reduxjs/toolkit';

export const deviceSlice = createSlice({
  name: 'devices',
  initialState: {
    cartTotal: 0,
    cartVat: 0,
    cartSubTotal: 0,
    cartCount: 0,
    cartShipping: 0,
    numberCount: 0,
    devicesList: [],
    devicesFilteredList: [],
    purchasedDevices: [],
    deviceBrand: [],
    deviceType: [],
    assigndevices: {},
    shippingAdd: {},
  },
  reducers: {
    setCartTotal: (state, action) => {
      state.cartTotal = action.payload;
    },
    setCartVat: (state, action) => {
      state.cartVat = action.payload;
    },
    setCartSubTotal: (state, action) => {
      state.cartSubTotal = action.payload;
    },
    setPurchasedDevices: (state, action) => {
      state.purchasedDevices = action.payload;
    },
    setDevicesList: (state, action) => {
      state.devicesList = action.payload;
    },
    setDevicesFilteredList: (state, action) => {
      state.devicesFilteredList = action.payload;
    },
    setDeviceBrand: (state, action) => {
      state.deviceBrand = action.payload;
    },
    setDeviceType: (state, action) => {
      state.deviceType = action.payload;
    },
    setCartShipping: (state, action) => {
      state.cartShipping = action.payload;
    },
    setCartCount: (state, action) => {
      state.cartCount = action.payload;
    },
    setAssignDevice: (state, action) => {
      state.assigndevices = action.payload;
    },
    setShippingAdd: (state, action) => {
      state.shippingAdd = action.payload;
    },
    setNumberCount: (state, action) => {
      state.numberCount = action.payload;
    },
  }
});

export const {
  setCartTotal,
  setCartVat,
  setCartSubTotal,
  setPurchasedDevices,
  setDeviceBrand,
  setDeviceType,
  setCartCount,
  setDevicesList,
  setAssignDevice,
  setDevicesFilteredList,
  setCartShipping,
  setShippingAdd,
  setNumberCount
} = deviceSlice.actions

export default deviceSlice.reducer;